/**
 * Maps country names to their ISO 3166-1 alpha-2 codes
 */
const countryNameToIsoCode = {
    'Canada': 'CA',
    'United States': 'US',
    'Ireland':'IE',
    'Mexico': 'MX',
    'UK': 'GB',
};

/**
 * Takes a country name and returns its ISO 3166-1 alpha-2 code
 * @param {string} countryName - The name of the country
 * @returns {string} - The ISO alpha-2 code or the original string if not found
 */
export function getCountryIsoCode(countryName) {
    if (!countryName || typeof countryName !== 'string') {
        return null;
    }
    
    // Try exact match first
    const exactMatch = countryNameToIsoCode[countryName];
    if (exactMatch) {
        return exactMatch;
    }
    
    // Try case-insensitive match
    const normalizedName = countryName.trim();
    for (const [name, code] of Object.entries(countryNameToIsoCode)) {
        if (name.toLowerCase() === normalizedName.toLowerCase()) {
            return code;
        }
    }
    
    return countryName;
}